import React, { useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import { trackVisit } from '@/lib/tracking';

interface LayoutProps {
  children: React.ReactNode;
}

import { Header } from './Header';
import { Footer } from './Footer';

export function Layout({ children }: LayoutProps) {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    trackVisit({
      page: location.pathname,
      email: searchParams.get('email'),
    }).catch(err => console.error('Visitor tracking error:', err));
  }, [location.pathname]);
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1 py-8" role="main">
        <div className="container-content">{children}</div>
      </main>
      <Footer />
    </div>
  );
}
